import { MelodyBaseUrl, LarkBaseUrl } from "./env.js";
import Vue from "vue";
import APIX from "./index";

//验证码
export const ApiCaptchaBase64 = (params) => {
  return APIX.POST(
    params,
    `${MelodyBaseUrl}memberuser/captchaBase64?uuid=${params.uuid}`
  );
};
//上下级转账
export const ApitransfertoMember = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}wallet/transfertoMember`)
}
export const APIMemberuserCheckCode = (params) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberuser/checkCode`);
};
//全部转回主账户
export const ApitransferToLocal = (params) => {
  return APIX.GET(params, `${MelodyBaseUrl}dsfplayer/transferToLocal`)
}
//分页得到股票K线
export const ApigupiaoklineQueryPage = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}gupiao/klineQueryPage`);
};
//股票概览
export const Apigupiaooverview = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}gupiao/overview`);
};
//余额宝总览
export const ApigetyebSummary = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/yebSummary`);
};
export const ApiyebCrQueryPage = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/yebCrQueryPage`);
};
export const ApiyebCarQueryPage = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/yebCarQueryPage`);
};
//获得审批状态的枚举
export const ApigetApproveStatus = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/getApproveStatus`);
};
//获得改变类型的枚举
export const ApigetChangeTypes = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/getChangeTypes`);
};
export const ApiyebTransferIn = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/yebTransferIn`);
};
export const ApiyebTransferOut = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}yeb/yebTransferOut`);
};
//查找符合条件的余额生金配置
export const ApigetbalanceincomerecordQueryByMu = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}balanceincomeconfig/queryByMu`);
};
//分页查找余额生金记录列表
export const ApigetbalanceincomerecordQueryPage = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}balanceincomerecord/queryPage`);
};
//昨日,今日预估,前日收益数据
export const ApigetIncomeSummary = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}balanceincomerecord/incomeSummary`);
};
//获取最新抢红包记录
export const ApigetNewestRedBagRecord = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}redBag/getNewestRedBagRecord`);
};
//获取抢红包活动信息
export const ApiredBagGetInfo = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}redBag/getInfo`);
};
//查询可抢红包次数
export const ApigetRedBagCount = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}redBag/getRedBagCount`);
};
//抢红包
export const ApigrabRedBag = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}redBag/grabRedBag`);
};
//获取公告列表
export const getByPage = (params) => {
  return APIX.POST(params, `${MelodyBaseUrl}notice/getByPage`);
};
//分页查询帐变记录
export const ApigetAccountChange = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}accountchange/queryPage`);
};
//获取帐变记录类型
export const ApigetAccountType = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}accountchange/getAccountType`);
};
//获取帐变记录详情
export const ApigetAccountDetail = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}accountchange/getById?` + t);
};
//获取滚动公告
export const ApigetByscroll = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}notice/getByScroll`);
};
//获取英雄版
export const ApigetAdminlooprewardList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}adminloopreward/getByPage`);
};
//首页轮播图
export const ApigetLoopimgList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}loopimg/list`);
};
//天奇数据
export const ApigetJackpot = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}bonuspool/getJackpot`);
};
//分页查询公告
export const ApigetNoticeList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}notice/getByPage`);
};
//分页查询弹窗公告
export const ApigetNoticePopup = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}notice/getByPop`);
};
//分页查询优惠活动
export const ApigetActivityList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}adminactivity/getByPage`);
};
//优惠活动分组
export const ApigetActivityGroup = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}adminactivity/getAllGroupName`);
};
//查询优惠活动
export const ApigetById = (params = {}, header) => {
  return APIX.POST(
    params,
    `${MelodyBaseUrl}adminactivity/getById?activityId=` + params.activityId
  );
};
//分页得到电子游戏列表
export const ApigetElegamePage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfgame/getElegamePage`);
};
//分页得到真人视讯列表
export const ApigetRealmanPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfgame/getRealmanHallPage`);
};
//分页得棋牌游戏列表
export const ApigetChessHallPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfgame/getChessPage`);
};
//分页得捕鱼游戏列表
export const ApigetFishHallPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfgame/getFishPage`);
};
//开始游戏
export const ApistartGame = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplayer/lanuchGame`);
};
//试玩开始游戏
export const ApiTryStartGame = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplayer/tryLanuchGame`);
};
//得到余额
export const ApigetBalance = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplayer/balance`);
};
//得到平台列表
export const ApigetPlatformList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplatform/list`);
};
//转入第三方平台
export const ApitransferIn = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplayer/transferIn`);
};
//转出第三方平台
export const ApitransferOut = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfplayer/transferOut`);
};
//转账列表
export const ApiqueryPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsftransferrecord/queryPage`);
};
//棋牌投注记录
export const ApiqueryPageChess = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfbet/queryPageChess`);
};
//电子投注记录
export const ApiqueryPageElegame = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfbet/queryPageElegame`);
};
//真人投注记录
export const ApiqueryPageRealman = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfbet/queryPageRealman`);
};
//电竞体育投注记录
export const ApiqueryPageSports = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfbet/queryPageSports`);
};
//捕鱼游戏列表
export const ApiquerygetFishPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}dsfgame/getFishPage`);
};
//获取热门彩种
export const ApigetLotteryListHot = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lottery/listHot`);
};
//获取所有的彩种
export const ApigetLotteryList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lottery/list`);
};
//购彩大厅
export const ApigetAllLotteryList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lottery/getLotteryLatelyLpVo`);
};
//彩票选号页面-》玩法树
export const ApigetLotteryTree = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}playway/getTreeByLtc?` + t);
};
//服务器时间
export const ApigetServerTime = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lottery/currentTime`);
};
//根据彩种获取赔率
export const ApigetMemRewardSeekBarVo = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}playwayreward/getMemRewardSeekBarVoList?` + t
  );
};
//普通订单提交
export const ApinormalBet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotteryorder/normalBet`);
};
//追号订单提交
export const ApichaseBet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotteryorder/chaseBet`);
};
//获取指定彩种的最近开奖记录
export const ApigetLatelyDrawedPeriods = (params = {}, header) => {
  // let t=Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}lotteryperiods/queryHisPeriodsPage`
  );
};
//获取当前期数开奖结果
export const ApigetQueryDrawNumber = (params = {}, header) => {
  // let t=Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}lotteryperiods/queryDrawNumber`
  );
};
//获取可追号期数
export const ApigetCanChasePeriods = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}lotteryperiods/getCanChasePeriods?` + t
  );
};
// 得到代理返水
export const ApigetProxyRpAmount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}/wallet/getWalletStsData`);
};
// 得到代理总投 总反水
export const ApigetSumProxyRpBet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}/memberuser/getSumProxyRpBet`);
};

//获取三方代理反水记录
export const ApigetDsfProxyRpRecord = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getDsfProxyRpRecord`);
};
//开奖大厅
export const ApigetAllLastPeriods = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lottery/getNewestDrawedPeriods`);
};
//分页查询彩票订单
export const ApigetLotteryOrder = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotteryorder/queryPage`);
};

//分页查询彩票注单
export const ApigetLotteryBetOrder = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotterybet/queryPage`);
};

//分页查询订单细节
export const ApigetLotteryOrderDetail = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}/orderDetail/queryPage`);
};

//根据id得到订单细节
export const ApigetOrderDetailById = (params = {}, header) => {
  let t = "?";
  t += Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST({}, `${MelodyBaseUrl}lottery/orderDetail/getById` + t);
};

//追号订单列表
export const ApigetLotteryListChase = (params = {}, header) => {
  let t = "?";
  t += Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST({}, `${MelodyBaseUrl}lotteryorder/listChase` + t);
};
//撤单
export const ApiMemCancelOrderDetail = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotteryorder/memCancelOrderDetail`);
};

//获取个人信息
export const ApigetMyAccountInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/current`);
};

//获取个人信息 完整版！
export const ApigetMyInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getInfo`);
};

//更新个人信息
export const ApiUpdateMyInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/updateMemberInfo`);
};

//获取个人报表
export const ApigetMyReport = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getPersonOverview`);
};

//获取团队报表
export const ApigetMyTeamReport = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getTeamOverview`);
};

//获取团队报表
export const ApigetTeamAmountBalance = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}memberuser/getTeamAmountBalance?` + t
  );
};

//获取下级列表
export const ApigetMylistLower = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/listLower`);
};
//新版带分页的查下级
export const APIqueryPageLower = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/queryPageLower`);
};

//修改密码
export const ApichangePassword = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/changePassword`);
};

//修改交易密码
export const ApiupdateWithdrawalPw = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wallet/changeTradePw`);
};

//获取代理反水记录
export const ApigetProxyRpRecord = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getProxyRpRecord`);
};

//获取我的代理总佣金
export const ApigetSumProxyRp = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getSumProxyRp`);
};

//获取代理彩票返点
export const ApigetListRpBonus = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/listRpBonus`);
};

//开户
export const ApiopenAccount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/openAccount`);
};
export const ApigetRechargeMergeData = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/mergeData`);
};
//获取邀请链接
export const ApigetPromoteLinkList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/promoteLinkList`);
};
export const ApiUpload = (params, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}oss/upload`);
};
//生成邀请链接
export const ApigenPromoteLink = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/promoteLinkGen`);
};

//更新邀请链接
export const ApiupdatePromoteLink = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/promoteLinkUpdate`);
};

//删除邀请链接
export const ApipromoteLinkDel = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/promoteLinkDel?` + t);
};

//获取信用玩法赔率
export const getMemRewardSeekBarVoListMap = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(
    params,
    `${MelodyBaseUrl}playwayreward/getMemRewardSeekBarVoListMap?` + t
  );
};

//修改下级人员信息
export const ApiupdateMemberAccount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/updateMemberAccount`);
};

//获取弹窗站未读数量
export const ApigetNoReadMsgCount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}websiteMessage/getNoReadMsgCount`);
};
//获取弹窗站内信
export const ApigetNoReadAndIsPopMsg = (params = {}, header) => {
  return APIX.POST(
    params,
    `${MelodyBaseUrl}websiteMessage/getNoReadAndIsPopMsg`
  );
};
//获取站内信
export const ApigetReceiveMessage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}websiteMessage/getReceiveMessage`);
};

//站内信已读
export const ApiMessageReadById = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}websiteMessage/readById?` + t);
};
//站内信批量已读
export const ApiMessageReadByIds = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}websiteMessage/readByIds`);
};
//站内信批量删除
export const ApiMessagedelByIds = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}websiteMessage/delByIds`);
};
//是否设置过交易密码
export const ApiIsHasPw = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/isSetTradePw`);
};

//用户等级列表
export const APIgetLevelList = (params, _this) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getLevelList`);
};

//设置交易密码
export const ApisetTraderPw = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wallet/setTradePw`);
};
//获取可用的扫码账户
export const ApigetEnabledDueScAccount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getEnabledDueScAccount`);
};
//充值记录列表
export const ApilistRecord = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/listRecord`);
};
//在线支付
export const Apionline = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/online`);
};
//在线支付通道支付
export const ApionlineByPayChannel = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/onlineByPayChannel`);
};
export const ApiLogin = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/login`);
};
export const ApiRegister = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/register`);
};
//用户注册必须携带的参数
export const ApiRetgistercolumn = (params = {}, header) => {
  return APIX.POST({ a: 123 }, `${MelodyBaseUrl}retgistercolumn/list`);
};
//当前域名是否为推广域名
export const ApiSysdomainQuery = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}sysdomain/query`);
};

export const ApiwxGroupMsgsend = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wxGroupMsg/send`);
};
export const ApiGetGroupByUser = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wxGroupUser/getGroupByUser`);
};
export const ApiLogout = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/logout`);
};
//
export const ApiUserInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getInfo`);
};
//用户权限信息
export const ApiMemberPermission2 = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getMemberPermission2`);
}
//反馈接口
export const Apifeedback = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}adminfeedback/feedback`);
};
//反馈列表
export const ApifeedbackList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}adminfeedback/queryPage`);
};
//站点资料（帮助中心）
export const ApigetWebsiteinfo = (params, _this) => {
  return APIX.POST(params, `${MelodyBaseUrl}websiteinfo/list`);
};
//查询应用配置
export const ApigetPageconfig = (params, _this) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}pageconfig/list?` + t);
};
//回复反馈
export const Apireply = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}adminfeedback/reply`);
};
export const Apiservice = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}sysparam/list`);
};
// 获取下载地址
export const ApigetSysparamListByCodes = (params, _this) => {
  return APIX.POST(params, `${MelodyBaseUrl}sysparam/listByCodes`);
};
//获取在线支付通道
export const ApigetPayChannelList = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getPayChannelList?` + t);
};
//获取可用的在线支付类型
export const ApigetEnabledOnlinePayType = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getEnabledOnlinePayType`);
};
//获取可用的收款银行卡
export const ApigetEnabledDueBankCard = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getEnabledDueBankCard`);
};
//获取可用的虚拟币充值通道
export const ApigetEnabledDueVcAccount = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getEnabledDueVcAccount`);
};
//获取提款范围
export const APIgetAmountLimit = (params = {}, _this) => {
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/amountLimit`);
};
//获取提款免手续费次数及本次提款手续费
export const APIgetDrawFeeStrategy = (params = {}, _this) => {
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/getDrawFeeStrategy`);
};

//扫码转账支付
export const ApiscTransfer = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/scTransfer`);
};
//在线支付
export const Apipayonline = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/online`);
};
//银行卡转账支付
export const ApibankTransfer = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/bankTransfer`);
};
//虚拟币转账支付
export const ApivcTransfer = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/vcTransfer`);
};
//获取个人收款钱包列表
export const APIgetmemberWithdrawWallet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberwithdrawalwallet/list`);
};
//设置默认钱包
export const APIdefaultSet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberwithdrawalwallet/defaultSet`);
};
//绑定收款钱包
export const APIbindMemberWithdrawWallet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberwithdrawalwallet/bind`);
};
//解绑收款钱包
export const APIunEnableMemberWithdrawWallet = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberwithdrawalwallet/unEnable`);
};
//会员银行卡列表
export const ApiBankLists = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberbankcard/list`);
};
//绑定银行卡
export const ApiBindCard = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberbankcard/bind`);
};
//获取银行卡类型列表
export const ApiBandsList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}bankcardType/list`);
};

//用户余额
export const ApigetUserBalance = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wallet/getBalance`);
};
//是否设置了交易密码s
export const ApiHasPw = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/isSetTradePw`);
};
//提现
export const Apidoit = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/doit`);
};

//设置提现
export const ApisetWithdrawPw = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wallet/setTradePw`);
};

//充值记录
export const ApirechargeList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/queryPage`);
};
//提现记录
export const ApiwithdrawalList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/queryPage`);
};
//提现记录查详情
export const ApiWithdrawalGetRecordById = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/getRecordById?` + t);
};
//充值记录查详情
export const ApiRechargeGetRecordById = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.POST(params, `${MelodyBaseUrl}recharge/getById?` + t);
};
//删除银行卡
export const ApideleteBankCard = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberbankcard/unEnable`);
};

//使用淘宝接口获取银行卡有效以及银行类型
export const ApiValidateAndCacheCardInfo = (params = {}, header) => {
  let t = Vue.prototype.$tools.objectToKeyVal(params);
  return APIX.GET(
    params,
    "https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?",
    true
  );
};

//
//大码信息
export const ApigetMemberDama = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberuser/getMemberDama`);
};

//当月签到查询
export const ApigetMemberSignInRecord = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/getMemberSignInRecord`);
};
//签到
export const ApigetMemberSignIn = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/memberSignIn`);
};
//签到规则信息
export const ApigetSignInExchangeConfig = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/getSignInExchangeConfig`);
};
//签到数据总览
export const ApigetSignInLogcStatisticsData = (params = {}, header) => {
  return APIX.POST(
    params,
    `${MelodyBaseUrl}signIn/getSignInLogcStatisticsData`
  );
};
//获取积分变动类型
export const ApigetIntegralChangeType = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/getIntegralChangeType`);
};
//获取积分记录
export const ApigetMemberIntegralExchangeRecord = (params = {}, header) => {
  return APIX.POST(
    params,
    `${MelodyBaseUrl}signIn/getMemberIntegralExchangeRecord`
  );
};
//获取当前积分
export const ApigetIntegralBalance = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/getIntegralBalance`);
};
//兑换积分
export const Apiexchange = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}signIn/exchange`);
};
//获取所有城市
export const ApigetAllCity = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}jiali/getAllCity`);
};
//获取佳丽类型
export const getAllStyle = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}jiali/getAllStyle
`);
};
//获取佳丽
export const ApijialiQueryPage = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}/jiali/queryPage`);
};
//根据id获取
export const ApijialiGetById = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}/jiali/getById?jialiId=${params.jialiId}`);
};
//im最近消息
export const ApiRecent = (params = {}, header) => {
  return APIX.POST(params, `${LarkBaseUrl}wxChat/recent`);
};
//im最近消息未读
export const ApiNotReadCount = (params = {}, header) => {
  return APIX.POST(params, `${LarkBaseUrl}wxChat/notReadCount`);
};
//im好友请求
export const ApiQueryPageFriendApplyLog = (params = {}, header) => {
  return APIX.POST(params, `${LarkBaseUrl}wxP2PChat/queryPageFriendApplyLog`);
};
//路子图数据

export const ApiGetLuzi = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}lotteryperiods/getLuzi`);
};
// 路子图配置
export const ApiGetLuziConfig = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}lotteryperiods/getLuziConfig`);
};
//------------------论坛
//查询论坛底部资料
export const ApifooterInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/footer/info`);
};
//分页查询所有帖子列表
export const ApiForumList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/post/list`);
};
//查询所有可用板块
export const ApiForumAll = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/area/all`);
};
//分页查询关注人帖子列表
export const ApiLikeList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/post/likeList`);
};
//分页查询自己的帖子列表
export const ApiMeList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/post/meList`);
};
//根据帖子id查询帖子
export const ApipostInfo = (params = {}, header) => {
  return APIX.POST({}, `${MelodyBaseUrl}forum/post/info?postId=${params.postId}`);
};
//分页查询资料推荐列表
export const ApiRecommendList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/recommend/list`);
};
//页查询评论列表
export const ApiCommentList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/comment/list`);
};
//发表评论
export const ApiCommentSave = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/comment/save`);
};
//发帖
export const ApiPostSave = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/post/save`);
};

//点赞
export const ApiLikeAdd = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/like/add`);
};
//取消点赞
export const ApiLikeRemove = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/like/remove`);
};
//关注
export const ApiFansLike = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/fans/like`);
};
//取消关注
export const ApiFansUnlike = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/fans/unlike`);
};
//分页查询回复列表
export const ApiReplayList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/replay/list`);
};

//发表回复
export const ApiReplaySave = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/replay/save`);
};
//查询粉丝列表
export const ApiFansList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/fans/list`);
};
//查询关注列表
export const ApiFansLikeList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/fans/likeList`);
};
// 查询帖子数量信息
export const ApigetCountInfo = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}forum/post/countInfo`);
};

// 挂单充值操作相关 start----
//挂单可充值列表
export const ApigetGuadanPayList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/queryPageByBuy`);
};


//根据充值订单号找到挂单充值记录
export const ApigetGuadanOrderInfo = (params = {}, header) => {
  return APIX.POST({}, `${MelodyBaseUrl}wrgdrechargerecord/getByOrderNo?rechargeOrderNo=${params.rechargeOrderNo}`);
};


//充值方取消挂单充值 

export const ApigetGuadanCancelRgd = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/cancelRgd`);
};

//提款方取消挂单提现
export const ApigetGuadanCancelWgd = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/cancelWgd`);
};


//提款方确认收款成功  
export const ApigetGuadanPaymentConfiredSuc = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/paymentConfiredSuc`);
};

//  充值方反馈投诉 

export const ApigetGuadanRgdFankuitousu = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/rgdFankuitousu`);
};

//充值方提交支付凭证 
export const ApigetGuadanSubmitPaymentVoucher = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/submitPaymentVoucher`);
};

//充值方查询挂单操作日志
export const ApigetGuadanQueryRgdOperLog = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdoperlogrecord/queryRgdOperLog`);
};

//提现方查询挂单操作日志
export const ApigetGuadanQueryQueryWgdOperLog = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdoperlogrecord/queryWgdOperLog`);
};

//查询提交笔数和 速度

export const ApigetGuadanGetCountSpeed = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/getCountSpeed`);
};

//根据提现单号找到挂单提现记录

export const ApigetGuadanGetByOrderNo = (params = {}, header) => {
  return APIX.POST({}, `${MelodyBaseUrl}wrgdwithdrawalrecord/getByOrderNo?withdrawalOrderNo=${params.withdrawalOrderNo}`);
};

//充值方已打款
export const ApigetGuadanAlreadyPaymented = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/alreadyPaymented`);
};

//充值方取消已打款
export const ApigetGuadanCancelAlreadyPaymented = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/cancelAlreadyPaymented`);
};

//挂单充值转账支付
export const ApigetGuadanrGdTransfer = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/rgdTransfer
    `);
};
//获取挂单充值状态枚举值

export const ApigetGuadanEnum = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdrechargerecord/getWrgdRechargeStatus
    `);
};

//获取挂单提现状态枚举值

export const ApigetGuadanTxEnum = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/getWrgdWithdrawStatus
    `);
};

//提款方反馈
export const ApigetGuadanTxFK = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/wgdFankuitousu
    `);
};

//挂单充值策略配置
export const ApiWrgdRechargeConfig = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}recharge/mathWrgdRechargeConfig`);
};
//挂单提现策略配置
export const ApiWrgdWithdrawConfig = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}withdrawal/mathWrgdWithdrawConfig`);
};

//接受买单

export const ApiWrgdWithdrawAcceptRgd = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}wrgdwithdrawalrecord/acceptRgd`);
};

// 挂单充值操作相关 end----

//活动大厅 start ---
//获取活动分组名称
export const ApigetMemberActivityGroupName = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberactivity/getAllGroupName`);
};

export const ApigetMemberActivityList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberactivity/queryPage`);
};

export const ApigetMemberActivityDetails = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberactivity/getById`);
};

export const ApigetMemberActivityApplyList = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberactivityapply/queryPage`);
};

export const ApiMemberActivityApply = (params = {}, header) => {
  return APIX.POST(params, `${MelodyBaseUrl}memberactivityapply/apply`);
};
export const ApiMemberActivityApplySum = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberactivityapply/getApplyStsSum`);
};
export const ApigetMemberActivityApplyDetails = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberactivityapply/getById`);
};

export const ApigetMemberActivityGetIngCanCompletedNum = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberactivity/getIngCanCompletedNum`);
};


//活动大厅 end ---

// 获取返点信息
export const ApigetProxyRp = (params = {}, header) => {
  return APIX.GET(params, `${MelodyBaseUrl}memberuser/getProxyRp`);
};

//获取图库接口
export const ApiqueryPic = (params = {}) => {
  return APIX.GET(params, `${MelodyBaseUrl}pic/list`);
}

//获取图库接口
export const ApiqueryPeriodc = (params = {}) => {
  return APIX.GET(params, `${MelodyBaseUrl}pic/period`);
}


//获取图库接口
export const ApiqueryDetail = (params = {}) => {
  return APIX.GET(params, `${MelodyBaseUrl}pic/detail`);
}



